var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"valora-iframe-wrapper"},[_c('iframe',{ref:"valoraIframe",attrs:{"src":_vm.urlValora(),"title":"Valora","frameborder":"0","scrolling":"no"},on:{"load":_vm.onIframeLoad}})])}
var staticRenderFns = []

export { render, staticRenderFns }